import { render, staticRenderFns } from "./KalustoSijaintiEditDialog.vue?vue&type=template&id=bcfbaa94&scoped=true"
import script from "./KalustoSijaintiEditDialog.vue?vue&type=script&lang=js"
export * from "./KalustoSijaintiEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfbaa94",
  null
  
)

export default component.exports